import React from 'react';
import { IonContent, IonPage } from '@ionic/react';

const BookingRoutes: React.FC = () => {
  return (
    <IonPage>
      <IonContent>
        {/* ...existing code... */}
      </IonContent>
    </IonPage>
  );
};

export default BookingRoutes;
